// src/pages/Dashboard.js
import React, { useEffect, useState } from "react";
import { Container, Typography, Grid, Paper, useTheme } from "@mui/material";
import { getDashboardOverview } from "../api/axios";

export default function Dashboard() {
  const theme = useTheme();
  const [stats, setStats] = useState({
    messagesSent: 0,
    delivered: 0,
    read: 0,
    // replies:    0,
  });

  let cancelled = false;

  useEffect(() => {
    async function fetchStats() {
      try {
        const { data } = await getDashboardOverview();
        setStats({
          messagesSent: data.stats.messagesSent ?? 0,
          delivered: data.stats.delivered ?? 0,
          read: data.stats.read ?? 0,
          // replies:    data.stats.replies      ?? 0,
        });
      } catch (err) {
        console.error("Error loading dashboard overview", err);
      }
    }
    fetchStats();

    // then poll every 30s
    const interval = setInterval(fetchStats, 30_000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  const cards = [
    {
      label: "Messages Sent",
      value: stats.messagesSent,
      color: theme.palette.primary.main,
    },
    {
      label: "Delivered",
      value: stats.delivered,
      color: theme.palette.success.main,
    },
    { label: "Read", value: stats.read, color: theme.palette.warning.main },
    // { label: 'Replies',       value: stats.replies,      color: theme.palette.secondary.main },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 0, mt: 0 }}>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        {cards.map(({ label, value, color }) => (
          <Grid item xs={12} sm={6} md={3} key={label}>
            <Paper
              elevation={3}
              sx={{
                backgroundColor: color,
                color: "#fff",
                p: 3,
                borderRadius: 2,
                height: 160,
                width: 300,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                {label}
              </Typography>
              <Typography variant="h4" fontWeight={700}>
                {value.toLocaleString()}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
